import useSWR from 'swr';
import fetcher from 'lib/fetcher';

export type APIRealtor = {
  id: number;
  name: string;
  phone: string;
  isMain: boolean;
};

export type APIRealtorsRes = {
  realtors: APIRealtor[];
};

const useRealtors = () => {
  const { data, error, isLoading, mutate } = useSWR<APIRealtorsRes>(
    '/users/realtors',
    fetcher.swr,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
    },
  );

  return { realtors: data?.realtors ?? [], error, isLoading, mutate };
};

export default useRealtors;
